import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useMsal } from "@azure/msal-react";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { memo } from "react";
import { debounce } from "lodash";
import "./chatBot.css";
import Spinner from "../Spinner/Spinner.jsx";
import eyLogo from "../../ey_logo.svg";
import chatBtn from "../../chat_btn.png";
import Typewriter from "../../components/Typewriter/Typewriter.jsx";
import CameraComponent from "../liveVideo/LiveVideo.jsx";
import SpeechToTextComponent from "../SpeechToText/SpeechToTextComponent.js";
import { useLocation } from "react-router-dom";
import Meg from "../../maeg.gif";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Custom Hook for managing session state
let isApiActive = false;
const useSession = () => {
  const [sessionId, setSessionId] = useState(
    sessionStorage.getItem("sessionId") || ""
  );

  const generateUniqueSessionId = useCallback(() => {
    const uuidPattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    const uuid = uuidPattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
    while (sessionStorage.getItem(uuid)) {
      return generateUniqueSessionId();
    }
    return uuid;
  }, []);

  useEffect(() => {
    document.body.style.backgroundImage = "url('../../src/VR Room.jpg')";
  }, []);

  useEffect(() => {
    if (!sessionId) {
      const newSessionId = generateUniqueSessionId();
      sessionStorage.setItem("sessionId", newSessionId);
      setSessionId(newSessionId);
    }
  }, [sessionId, generateUniqueSessionId]);

  return sessionId;
};

const AvatarChatBot = () => {
  const [start, setStart] = useState(false);
  const [isInterrupt, setIsInterrupt] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [bidders, setBidders] = useState([]);
  const [displayChat, setDisplayChat] = useState(false);
  const [lisaResponse, setLisaResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVoiceActivated, setIsVoiceActivated] = useState(false);
  const [speak, setSpeak] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pageRefresh, setPageRefresh] = useState(false);
  const [childData, setChildData] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [bidText, setBidText] = useState("");
  const [showBid, setShowBid] = useState(false);
  const [richardAnalysing, setRichardAnalysing] = useState(false);
  const [lisaAnalysing, setLisaAnalysing] = useState(false);
  const [recognizedText, setRecognizedText] = useState("");
  const [disableItem, setDisableItem] = useState(false);
  const [avatarLoaded, setAvatarLoaded] = useState(false);

  const [speaking, setSpeaking] = useState([
    {
      yetToSpeak: false,
      avatarID: "Justin_public_3_20240308_black",
      isSpeaking: false,
    },
    {
      yetToSpeak: false,
      avatarID: process.env.REACT_APP_AVATAR_ID_KLAUS,
      isSpeaking: false,
    },
  ]);
  const [avatarSession, setAvatarSession] = useState(false);
  const location = useLocation();
  const state = location.state;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userSignInMessage, setUserSignInMessage] = useState("");
  const sessionId = useSession();
  const [hideImage, setImageHide] = useState(true);
  const [trackRecieved, setTrackReceived] = useState(false);
  const { instance } = useMsal();
  const navigate = useNavigate();

  const peerConnectionRef = useRef(null);
  const avatarSynthesizerRef = useRef(null);
  const [isSpeakingDisabled, setIsSpeakingDisabled] = useState(false);
  const [isStopSpeakingDisabled, setIsStopSpeakingDisabled] = useState(true);
  const audioRef = useRef(null);
  const [videoElement, setVideoElement] = useState(null);
  const [isSessionActive, setIsSessionActive] = useState(false); // New state to track session status
  const accessToken = useSelector((state) => state.auth.accessToken);
  const [speechToken, setSpeechToken] = useState(null); // Fetched Speech Token
  const [speechRegion, setSpeechRegion] = useState(null); // Fetched Speech Region

  const refreshTokenInterval = useRef(null); // Store token refresh interval
  const setupWebRTC = (
    iceServerUrl,
    iceServerUsername,
    iceServerCredential,
    avatarConfig,
    speechSynthesisConfig
  ) => {
    console.log("Setting up WebRTC with ICE server:", iceServerUrl); // Log ICE server info

    const peerConnection = new RTCPeerConnection({
      iceServers: [
        {
          urls: [iceServerUrl],
          username: iceServerUsername,
          credential: iceServerCredential,
        },
      ],
      iceTransportPolicy: "all",
    });

    // Log when the connection is established
    peerConnection.oniceconnectionstatechange = () => {
      console.log(
        "WebRTC ICE connection state:",
        peerConnection.iceConnectionState
      );
      if (peerConnection.iceConnectionState === "connected") {
        console.log("WebRTC connection established.");
      }
    };

    // Log when a track is received
    peerConnection.ontrack = (event) => {
      console.log("Track event received:", event); // Log the track event
      const mediaElement = document.createElement(event.track.kind);
      mediaElement.srcObject = event.streams[0];
      mediaElement.autoplay = true;
      mediaElement.style.display = "block";
      mediaElement.style.marginTop = "20px";

      setVideoElement(mediaElement); // Set the video element in the state
      setIsSessionActive(true);
      setLoading(false);

      document.getElementById("remoteVideo").appendChild(mediaElement);
    };

    // Log ICE candidates
    peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        console.log("New ICE candidate:", event.candidate);
      } else {
        console.log("All ICE candidates have been sent.");
      }
    };

    // Add transceivers for video and audio
    peerConnection.addTransceiver("video", { direction: "sendrecv" });
    peerConnection.addTransceiver("audio", { direction: "sendrecv" });

    const avatarSynthesizer = new SpeechSDK.AvatarSynthesizer(
      speechSynthesisConfig,
      avatarConfig
    );
    avatarSynthesizer
      .startAvatarAsync(peerConnection)
      .then(() => {
        console.log("Avatar started successfully.");
      })
      .catch((error) => {
        console.error("Avatar failed to start:", error);
      });

    peerConnectionRef.current = peerConnection;
    avatarSynthesizerRef.current = avatarSynthesizer;
  };

  // Fetch Speech Token and Region from API
  const fetchSpeechToken = async () => {
    try {
      const endpoint =
        process.env.REACT_APP_AVATAR_API_GET_SPEECH_TOKEN_ENDPOINT;

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          unique_id: sessionId,
        }),
      };

      const response = await fetch(endpoint, options);
      const data = await response.json();

      const { token, region } = data;
      setSpeechToken(token);
      setSpeechRegion(region);
    } catch (error) {
      console.error("Error fetching speech token:", error);
    }
  };

  // Initial fetch
  useEffect(() => {
    if (accessToken && sessionId) {
      fetchSpeechToken();
    }
  }, [accessToken, sessionId]);

  // Refresh token every 9 minutes (token is valid for 10)
  useEffect(() => {
    if (speechToken && speechRegion && accessToken && sessionId) {
      refreshTokenInterval.current = setInterval(() => {
        fetchSpeechToken();
      }, 9 * 60 * 1000); // 9 minutes

      return () => {
        clearInterval(refreshTokenInterval.current);
      };
    }
  }, [speechToken, speechRegion, accessToken, sessionId]);

  const startSession = () => {
    // Validate that all required data is available before starting
    if (!speechToken || !speechRegion) {
      console.error("Cannot start session: Speech token or region is missing");
      alert("Please wait for the system to initialize before starting interaction.");
      return;
    }

    if (!accessToken) {
      console.error("Cannot start session: Access token is missing");
      alert("Authentication required. Please refresh the page.");
      return;
    }

    if (!sessionId) {
      console.error("Cannot start session: Session ID is missing");
      alert("Session not initialized. Please refresh the page.");
      return;
    }

    if (avatarSynthesizerRef.current) {
      avatarSynthesizerRef.current.close();
    }
    if (peerConnectionRef.current) {
      peerConnectionRef.current.close();
    }
    setVideoElement(null);
    setIsSessionActive(false); // Update session status to inactive
    // This will remove the video element from the state, causing it to be unmounted
    setIsSessionActive(true);
    // After fetching token and region from your API (e.g., fetchSpeechToken function)
    const speechSynthesisConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
      speechToken,
      speechRegion
    );

    const videoFormat = new SpeechSDK.AvatarVideoFormat();

    videoFormat.setCropRange(
      new SpeechSDK.Coordinate(100, 0),
      new SpeechSDK.Coordinate(1720, 1080)
    );
    const avatarConfig = new SpeechSDK.AvatarConfig(
      "Meg",
      "business",
      videoFormat
    );
    avatarConfig.customized = 0;
    avatarConfig.backgroundColor = "#000000FF"; // Fully black background
    avatarConfig.backgroundImage = null;
    const web_rtc_token_endpoint =
      process.env.REACT_APP_AVATAR_API_WEBRTC_TOKEN_RESPONSE_ENDPOINT;
    const options2 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        unique_id: sessionId,
      }),
    };
    fetch(web_rtc_token_endpoint, options2)
      .then((response) => response.json())
      .then((data) => {
        const { Urls, Username, Password } = data;
        setupWebRTC(
          Urls[0],
          Username,
          Password,
          avatarConfig,
          speechSynthesisConfig
        );
      })
      .catch((error) => console.error("Error fetching WebRTC token:", error));
  };

  const startSpeaking = (res) => {
    setIsSpeakingDisabled(true);
    setIsStopSpeakingDisabled(false);
    if (audioRef.current) {
      audioRef.current.muted = false;
    }

    const spokenText = formatText(res);
    const ttsVoice = "en-US-AvaMultilingualNeural";
    const personalVoiceSpeakerProfileID = null;
    const spokenSsml = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xml:lang='en-US'><voice name='${ttsVoice}'><mstts:ttsembedding speakerProfileId='${personalVoiceSpeakerProfileID}'><mstts:leadingsilence-exact value='0'/>${spokenText}</mstts:ttsembedding></voice></speak>`;
    setLoading(false);
    avatarSynthesizerRef.current
      .speakSsmlAsync(spokenSsml)
      .then((result) => {
        setIsSpeakingDisabled(false);
        setIsStopSpeakingDisabled(true);
        if (
          result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted
        ) {
          setDisableItem(false);
        } else {
          setDisableItem(false);
          if (result.reason === SpeechSDK.ResultReason.Canceled) {
            const cancellationDetails =
              SpeechSDK.CancellationDetails.fromResult(result);
            console.log(cancellationDetails.reason);
            if (
              cancellationDetails.reason === SpeechSDK.CancellationReason.Error
            ) {
              console.log(cancellationDetails.errorDetails);
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
        setIsSpeakingDisabled(false);
      });
  };

  function formatText(input) {
    // Replace special HTML characters with their corresponding HTML entities
    const formatted = input
      .replace(/&/g, "&amp;") // Replace & with &amp;
      .replace(/</g, "&lt;") // Replace < with &lt;
      .replace(/>/g, "&gt;") // Replace > with &gt;
      .replace(/"/g, "&quot;") // Replace " with &quot;
      .replace(/'/g, "&#39;") // Replace ' with &#39;
      .trim(); // Trim whitespace from both ends of the string

    return formatted;
  }

  // Function to handle button click for fetching responses
  const handleButtonClick = useCallback(
    async (data) => {
      setIsInterrupt(false);
      const queryData = data;
      setDisplayChat(true);
      setRecognizedText(queryData);
      setLisaAnalysing(true);
      setDisableItem(true);
      setInputValue("");
      setLoading(true);
      try {
        const query_response_endpoint =
          process.env.REACT_APP_AVATAR_API_GET_QUERY_RESPONSE_ENDPOINT;
        const options2 = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            query: queryData,
            unique_id: sessionId,
          }),
        };
        const res = await fetch(query_response_endpoint, options2);
        if (res.status === 200) {
          const data = await res.json();
          setLoading(false);
          setLisaResponse(data.Klaus_response); // ✅ Assign full response
          startSpeaking(data.Klaus_response); // ✅ Trigger speaking with full response
        } else {
          console.warn("Klaus response API returned status:", res.status);
        }
      } catch (error) {
        setLoading(false);
      } finally {
        isApiActive = false;
      }
    },
    [sessionId, isVoiceActivated]
  );

  const handleButtonClickChatSingle = useCallback(async () => {
    const currentInputValue = inputValue;
    setDisplayChat(true);
    setRecognizedText(currentInputValue);
    setLisaAnalysing(true);
    setDisableItem(true);
    setInputValue("");
    setLoading(true);
    setBidders([]);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_AVATAR_BEARER_TOKEN}`,
      },
      body: JSON.stringify({ query: currentInputValue, unique_id: sessionId }),
    };
    try {
      const query_response_endpoint =
        process.env.REACT_APP_AVATAR_API_GET_QUERY_RESPONSE_ENDPOINT;
      const options2 = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          query: currentInputValue,
          unique_id: sessionId,
        }),
      };

      const res = await fetch(query_response_endpoint, options2);
      if (res.status === 200) {
        const data = await res.json();
        setLisaResponse(data.Klaus_response); // ✅ Assign full response
        startSpeaking(data.Klaus_response); // ✅ Trigger speaking with full response
      } else {
        console.warn("Klaus response API returned status:", res.status);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [inputValue, sessionId]);

  const firstRender = React.useRef(true);

  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false; // Mark first render as complete
      if (state?.signInSuccess || state?.loggedIn) {
        setUserSignInMessage("");
        setIsVoiceActivated(false);
      }
    }
  }, [pageRefresh]); // Runs
  useEffect(() => {
    if (sessionStorage.getItem("refreshKey") == "ON") {
      sessionStorage.setItem("refreshKey", "OFF");
      console.log("called");
      setIsVoiceActivated(true);
      setLoading(true);
      startSession();
    }
  }, []);
  const hasStartedSession = useRef(false); // Create a ref to track if the session has started

  // Function to handle input change
  const handleInputChange = useCallback((event) => {
    setInputValue(event.target.value);
  }, []);

  // Function to handle transcript change
  const handleTranscriptChange = useCallback(
    debounce((newTranscript) => {
      setInputValue(newTranscript);
      if (newTranscript && newTranscript.length > 0 && !isApiActive) {
        isApiActive = true;
        handleButtonClick(newTranscript);
      }
    }, 500),
    [handleButtonClick]
  );

  // Function to handle data from child component
  const handleDataFromChild = useCallback((data) => {
    setChildData(data);
  }, []);

  // Function to determine the active speaker
  const activeSpeaker = useMemo(() => {
    setIsVisible(true);
    setRichardAnalysing(false);
    setLisaAnalysing(false);
    const yetToSpeakMember = speaking.find((element) => element.yetToSpeak);
    if (yetToSpeakMember) {
      if (yetToSpeakMember.avatarID === "Justin_public_3_20240308_black") {
        setShowBid(false);
        setRichardAnalysing(true);
        setDisableItem(false);
        return "Richard has the floor...";
      } else {
        setShowBid(false);
        setLisaAnalysing(true);
        setDisableItem(false);
        return "";
      }
    } else {
      return "";
    }
  }, [speaking]);

  // Effect to hide the bid text after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, [isVisible]);

  function handleRefresh() {
    sessionStorage.setItem("fromSignIn", true);
    window.location.reload();
  }

  const handleLogout = async () => {
    try {
      const logoffEndpoint = process.env.REACT_APP_AVATAR_API_LOGOFF_ENDPOINT;
      // logoff API called
      const response = await fetch(logoffEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ unique_id: sessionId }),
      });
      if (response.status !== 200) {
        console.warn("Logoff API returned non-200 status:", response.status);
      }
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/logout-success", { replace: true });
    }
  };

  // Function to handle toggle button click
  function toggleVoice() {
    if (!isVoiceActivated) {
      setIsVoiceActivated(true);
      setLoading(true);
      startSession();
    } else {
      handleRefresh();
    }
  }

  return (
    <div>
      <div className="my-background">
        <div className="header">
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              height="40px"
              width="40px"
              style={{ margin: "10px" }}
              src={eyLogo}
              alt="Logo"
            />
            <h2 className="heading">Mobility - GTM Factory</h2>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <a onClick={() => navigate('/dashboard')} className="logout-button" style={{ marginRight: "16px" }}>
              Growth Hacks
            </a>
            <a onClick={handleLogout} className="logout-button">
              Logout
            </a>
          </div>
        </div>
        <>
          <div class="chatbotcontainer">
            <div className="container back_style">
              <div className="row no-gutter marFix">
                <div className="col-md-4 col-lg-4"></div>
                <div className="col-md-4 col-lg-4">
                  <div className="overlay-div-2">
                    <div
                      className="avatar-container2"
                      style={{ color: "white" }}
                    >
                      {!isVoiceActivated ? (
                        <img
                          src={Meg}
                          alt="Loading..."
                          style={{
                            width: "350%", // Increase width by 300%
                            height: "170%", // Increase height by 300%
                          }}
                        />
                      ) : (
                        <div
                          id="remoteVideo"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            marginTop: "20px", // Add space above the video
                            position: "absolute",
                            width: "100%", // Set width to 100% of the parent container
                            height: "auto", // Set height to auto to maintain aspect ratio
                          }}
                        ></div>
                      )}
                      <div>{lisaResponse && lisaAnalysing && !isInterrupt}</div>
                      {lisaResponse && lisaAnalysing && !isInterrupt && (
                        <div
                          className="speechTxt-2 active"
                          style={{
                            boxShadow: "0 0 20px rgba(255, 255, 255, 0.9)",
                          }}
                        >
                          <div className="responseDiv">
                            <Typewriter text={lisaResponse} userName="Liza: " />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="waitingMsg">
                    {loading ? (
                      <>
                        <Spinner />
                        <div style={{ color: "white", textAlign: "center" }}>
                          <b style={{ fontSize: "12px" }}>
                            <div>Avatar is busy at the moment</div>
                            <div>Please wait</div>
                          </b>
                        </div>
                      </>
                    ) : null}

                    {(showBid ||
                      ((speaking[0].yetToSpeak ||
                        speaking[1].yetToSpeak ||
                        disableItem) &&
                        isInterrupt)) && (
                      <div
                        className="bidText"
                        style={{
                          position: "absolute",
                          fontSize: "6em", // Increased font size for better readability
                          color: "#FFC72C", // EY yellowish color
                          marginTop: "10px",
                          background: "none",
                          padding: "0",
                          fontFamily: "Orbitron, sans-serif",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "30px",
                          textAlign: "center",
                          borderRadius: "20px",
                          boxShadow: "0 0 40px rgba(255, 199, 44, 0.9)", // Reduced glow
                          animation:
                            "glow 1s infinite alternate, fade 0.7s infinite alternate, loading 0.6s infinite",
                          zIndex: 10, // Ensure it's on top
                          marginLeft: "185px",
                        }}
                      >
                        <style>
                          {`
                @keyframes glow {
                    from {
                        box-shadow: 0 0 20px rgba(255, 199, 44, 0.9), 0 0 30px rgba(255, 199, 44, 0.8), 0 0 40px rgba(255, 199, 44, 0.7), 0 0 50px rgba(255, 199, 44, 0.6);
                    }
                    to {
                        box-shadow: 0 0 990px rgba(255, 199, 44, 1), 0 0 70px rgba(255, 199, 44, 0.9), 0 0 80px rgba(255, 199, 44, 0.8), 0 0 90px rgba(255, 199, 44, 0.4);
                    }
                }
                .animated-shadow {
                    animation: glow 1s infinite alternate;
                }
                `}
                        </style>
                        <Typewriter
                          text={bidText}
                          userName=""
                          onTypingEnd={() => {
                            const bidTextElement =
                              document.querySelector(".bidText");
                            if (bidTextElement) {
                              bidTextElement.style.animation =
                                "heartbeat 0.5s ease-in-out infinite";
                            }
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4"></div>
              </div>
            </div>

            <div className="row no-gutter">
              <div className="chat_section">
                <div className="row">
                  <div className="col-md-2"></div>
                  <div className="col-md-6">
                    <div className="chatBox_section">
                      <div className="chatBox">
                        {displayChat && !isInterrupt && (
                          <div className="chatMessage">
                            <div>You: {recognizedText}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2"></div>
                </div>
                <div className="row control_Section">
                  <div className="col-md-1"></div>
                  <div className="col-md-9">
                    <div className="chat-container">
                      <button 
                        className="startBtn" 
                        onClick={toggleVoice}
                        disabled={!speechToken || !speechRegion || !accessToken || !sessionId}
                        style={{
                          opacity: (!speechToken || !speechRegion || !accessToken || !sessionId) ? 0.5 : 1,
                          cursor: (!speechToken || !speechRegion || !accessToken || !sessionId) ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {!speechToken || !speechRegion ? "Initializing..." : 
                         isVoiceActivated ? "Stop Interaction" : "Start Interaction"}
                      </button>
                      <input
                        className="chatContent"
                        style={{
                          background:
                            (speaking[1].yetToSpeak && !isVoiceActivated) ||
                            disableItem
                              ? "#747480"
                              : "",
                        }}
                        type="text"
                        value={inputValue}
                        onChange={handleInputChange}
                        placeholder="Enter your message"
                        disabled={!isVoiceActivated || disableItem}
                      />
                      <button
                        className="chatButton"
                        onClick={handleButtonClickChatSingle}
                        style={{
                          background:
                            !isVoiceActivated || disableItem ? "#747480" : "",
                        }}
                        disabled={!isVoiceActivated || disableItem}
                      >
                        <img
                          height="50px"
                          width="50px"
                          src={chatBtn}
                          alt="chat"
                        />
                      </button>

                      <SpeechToTextComponent
                        onTranscriptChange={handleTranscriptChange}
                        onData={handleDataFromChild}
                        disableItem={
                          !isVoiceActivated || disableItem ? "#747480" : ""
                        }
                      />

                      <button
                        className="stopBtn"
                        style={{ width: "100px", zIndex: "10000" }}
                        onClick={handleRefresh}
                      >
                        Interrupt
                      </button>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="outer">
                      <div className="camera">
                        <CameraComponent />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default memo(AvatarChatBot);
